<template>
    <div id="main-container">
        <div class="navbar-container" style="position: fixed; top: 0; left: 0; right: 0; z-index: 999;">
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
                <div v-if="transaction && transaction.payment_link && transaction.payment_status == 'PAYMENT'"
                    class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link"
                            @click.prevent="refreshIframe" :disabled="isSpinning">
                            <font-awesome-icon icon="refresh" class="text-secondary"
                                :class="{ 'spin-animation': isSpinning }" />
                        </router-link>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </div>
        <div class="scrollable-container" style="background-color: white;">
            <div class="content">
                <div v-if="transaction && transaction.payment_link" class="w-100">
                    <iframe id="iframe-payment" :src="transaction.payment_link" class="w-100" frameborder="0"
                        style="height: 100vh; z-index: 99999;">
                    </iframe>
                </div>
                <div v-else class="w-100 p-3">
                    <div v-if="!loading" class="d-flex flex-column justify-content-center align-items-center text-center">
                        <img id="img-card" class="img-card" src="@/assets/images/logo-empty.png" />
                        <div v-if="transaction.payment_link == null" class="d-flex flex-column">
                            <label class="mt-4 mb-1 font-weight-bold">
                                {{ $t('Your payment link is not loaded correctly!') }}
                            </label>
                            <label class="text-muted">
                                {{ $t('Please contact our support or try the refresh button below') }}
                            </label>
                            <div class="d-flex flex-row justify-content-center align-items-center mt-4">
                                <button class="btn btn-main d-flex align-items-center" @click.prevent="generatePaymentLink"
                                    :disabled="loading">
                                    <font-awesome-icon icon="redo" class="mr-2" /><span style="margin-bottom: 1px;">{{
                                        $t('Refresh')
                                    }}</span>
                                </button>
                            </div>
                        </div>
                        <div v-else class="d-flex flex-column">
                            <label class="mt-4 mb-1 font-weight-bold">{{ $t('Something went wrong!') }}</label>
                            <label class="text-muted">
                                {{ $t('Please contact our support') }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import TransactionService from "@/services/transaction.service";

export default {
    name: "PaymentGateway",
    components: {
        //
    },
    data() {

        return {
            loading: false,
            isSpinning: false,
            isModalShown: false,
            transaction_id: null,
            transaction: null,
            intervalId: null,
            from: null,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
    },
    created() {
        this.loading = true;
        let loader = this.$loading.show();
        if (!this.$route.query.data) {
            this.loading = false;
            loader.hide();
            this.$router.push({
                name: "Cart",
            });
        } else {
            let decrypted = this.$decryptString(this.$route.query.data, 'encryptKey');
            if (decrypted == null) {
                this.loading = false;
                loader.hide();
                this.navigateBackOrHome();
            } else {
                this.from = this.$route.query.from;

                this.transaction_id = decrypted;
                this.startInterval();

                let interval = setInterval(() => {
                    if (this.loading == false) {
                        loader.hide();
                        clearInterval(interval);
                    }
                }, 1000);
            }
        }
    },
    methods: {
        refreshIframe() {
            this.isSpinning = true;

            this.refreshData();

            setTimeout(() => {
                this.isSpinning = false;
            }, 1000);
        },

        refreshData() {
            this.loading = true;
            let loader = this.$loading.show();

            if (this.intervalId) {
                this.removeInterval();
            }

            let invoice_number = { invoice_number: this.transaction.invoice_number };
            if (this.transaction) {
                TransactionService
                    .status(invoice_number)
                    .then((response) => {
                        this.loading = false;
                        loader.hide();

                        if (response.data.status === "success") {
                            this.transaction = response.data.data;
                            if (this.transaction.payment_status == 'SUCCESS') {
                                this.removeInterval();
                                if (this.from == null) {
                                    this.$vueAlert.alert(this.$t('Payment successful!'), null, 'success').then(() => {
                                        this.removeInterval();
                                        this.$router.push({
                                            name: "Transaction",
                                        });
                                    });
                                }
                            } else if (this.transaction.payment_status == 'DRAFT' || this.transaction.payment_status == 'PAYMENT') {
                                if (this.transaction.payment_link && document.getElementById('iframe-payment')) {
                                    this.startInterval();
                                    document.getElementById('iframe-payment').src = this.transaction.payment_link;
                                }
                            } else {
                                this.removeInterval();
                                if (this.from == null) {
                                    this.$vueAlert.alert(this.$t(this.transaction.payment_status), this.$t('Payment Failed'), 'error').then(() => {
                                        this.removeInterval();
                                        this.$router.push({
                                            name: "Transaction",
                                        });
                                    });
                                }
                            }
                        } else {
                            this.$vueAlert.alert(response.data.message, null, response.data.status).then(() => {
                                this.startInterval();
                            });
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        loader.hide();

                        let errorMessage = this.$t('An error occurred');
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("auth/logout");
                                this.$router.push('/login');
                                return; // Exit the function after handling 401
                            }

                            // Check if the message is available in the error response
                            if (error.response.data && error.response.data.message) {
                                errorMessage = error.response.data.message;
                            } else if (error.response.statusText) {
                                // Fallback to statusText if message is not available
                                errorMessage = error.response.statusText;
                            }
                        } else if (error.message) {
                            // Fallback to error.message if response is not available
                            errorMessage = error.message;
                        }

                        this.$vueAlert.alert(errorMessage, null, 'error').then(() => {
                            this.startInterval();
                        });
                    });
            } else {
                this.startInterval();

                let interval = setInterval(() => {
                    if (this.loading == false) {
                        loader.hide();
                        clearInterval(interval);
                    }
                }, 1000);
            }
        },

        fetchData(id, refreshIframe = false) {
            TransactionService
                .show(id)
                .then((response) => {
                    this.loading = false;
                    if (response.data.status === "success") {
                        this.transaction = response.data.data;
                        if (this.transaction.payment_link == null) {
                            this.removeInterval();
                        }

                        if (refreshIframe && this.transaction.payment_link && document.getElementById('iframe-payment')) {
                            document.getElementById('iframe-payment').src = this.transaction.payment_link;
                        }
                    } else {
                        this.removeInterval();
                        this.$vueAlert.alert(response.data.message, null, response.data.status).then(() => {
                            this.navigateBackOrHome();
                        });
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    this.removeInterval();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error').then(() => {
                        this.navigateBackOrHome();
                    });
                });
        },

        startInterval() {
            if (this.intervalId) {
                this.removeInterval();
            }

            this.intervalId = setInterval(() => {
                if (this.transaction) {
                    if (this.transaction.payment_status !== 'DRAFT' && this.transaction.payment_status !== 'PAYMENT') {
                        if (this.transaction.payment_status == 'SUCCESS') {
                            this.removeInterval();

                            if (this.isModalShown == false) {
                                this.isModalShown = true;

                                if (this.from == null) {
                                    this.$vueAlert.alert(this.$t('Payment successful!'), null, 'success').then(() => {
                                        this.removeInterval();
                                        this.isModalShown = false;

                                        this.$router.push({
                                            name: "Transaction",
                                        });
                                    });
                                }
                            }
                        } else {
                            this.removeInterval();

                            if (this.isModalShown == false) {
                                this.isModalShown = true;

                                if (this.from == null) {
                                    this.$vueAlert.alert(this.$t(this.transaction.payment_status), this.$t('Payment Failed'), 'error').then(() => {
                                        this.removeInterval();
                                        this.isModalShown = false;

                                        this.$router.push({
                                            name: "Transaction",
                                        });
                                    });
                                }
                            }
                        }
                    } else {
                        if (this.transaction.payment_expiry_date) {
                            const currentDate = new Date();
                            const paymentExpiryDate = new Date(this.transaction.payment_expiry_date);

                            if (currentDate > paymentExpiryDate) {
                                this.removeInterval();

                                if (this.isModalShown == false) {
                                    this.isModalShown = true;

                                    if (this.from == null) {
                                        this.$vueAlert.alert(this.$t('Payment link has expired!'), this.$t('Payment Failed'), 'error').then(() => {
                                            this.removeInterval();
                                            this.isModalShown = false;

                                            this.$router.push({
                                                name: "Transaction",
                                            });
                                        });
                                    }
                                }
                            }
                        }
                    }
                }

                this.fetchData(this.transaction_id, false);
            }, 2500);
        },

        removeInterval() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },

        generatePaymentLink() {
            this.loading = true;
            let loader = this.$loading.show();

            let id = this.transaction.id;
            if (this.transaction) {
                TransactionService
                    .generatePaymentLink(id)
                    .then((response) => {
                        this.loading = false;
                        loader.hide();

                        if (response.data.status === "success") {
                            this.$vueAlert.alert(this.$t('Payment link has been successfully refreshed!'), null, 'success').then(() => {
                                this.transaction = response.data.data;
                                if (this.transaction.payment_link && document.getElementById('iframe-payment')) {
                                    document.getElementById('iframe-payment').src = this.transaction.payment_link;
                                }
                            });
                        } else {
                            this.$vueAlert.alert(response.data.message, null, response.data.status);
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        loader.hide();

                        let errorMessage = this.$t('An error occurred');
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("auth/logout");
                                this.$router.push('/login');
                                return; // Exit the function after handling 401
                            }

                            // Check if the message is available in the error response
                            if (error.response.data && error.response.data.message) {
                                errorMessage = error.response.data.message;
                            } else if (error.response.statusText) {
                                // Fallback to statusText if message is not available
                                errorMessage = error.response.statusText;
                            }
                        } else if (error.message) {
                            // Fallback to error.message if response is not available
                            errorMessage = error.message;
                        }

                        this.$vueAlert.alert(errorMessage, null, 'error');
                    });
            } else {
                this.loading = false;
                loader.hide();
                this.$vueAlert.alert(this.$t('Your payment link is not loaded correctly!'), null, 'error');
            }
        },

        resizePage() {
            if (document.getElementById('main-container')) {
                let deviceWidth = window.matchMedia("(max-width: 1024px)");
                if (deviceWidth.matches) {
                    document.getElementById('main-container').style.height = window.innerHeight + 'px';
                } else {
                    document.getElementById('main-container').style.height = '100vh';
                }

                if (document.getElementsByClassName('navbar-container')[0] && document.getElementsByClassName('scrollable-container')[0]) {
                    let mainContainerHeight = document.getElementById('main-container').offsetHeight;
                    let navbarContainerHeight = document.getElementsByClassName('navbar-container')[0].offsetHeight;

                    document.getElementsByClassName('scrollable-container')[0].style.height = (mainContainerHeight - navbarContainerHeight - 7) + 'px';
                    document.getElementsByClassName('scrollable-container')[0].style.marginTop = navbarContainerHeight + 'px';

                    if (this.transaction && this.transaction.payment_link && document.getElementById('iframe-payment')) {
                        document.getElementById('iframe-payment').style.height = (mainContainerHeight - navbarContainerHeight - 7) + 'px';
                    }
                }
            }
        },

        goBack() {
            this.removeInterval();

            if (!this.transaction) {
                this.navigateBackOrHome();
            }
            if (this.transaction.status == 'DRAFT') {
                this.$vueAlert.fire({
                    title: null,
                    text: this.$t('Are you sure you want to cancel this payment?'),
                    type: 'question',
                    showConfirmButton: true,
                    showCancelButton: true,
                    reverseButtons: true,
                    confirmButtonText: this.$t('Cancel Payment'),
                    cancelButtonText: this.$t('Back'),
                    confirmButtonColor: '#275D93',
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: 'btn btn-outline-main',
                        cancelButton: 'btn btn-main mr-2',
                    },
                }).then((result) => {
                    if (result.value) {
                        TransactionService
                            .cancelPayment(this.transaction_id)
                            .then(() => {
                                this.navigateBackOrHome();
                            })
                            .catch(() => {
                                this.navigateBackOrHome();
                            });
                    }
                });
            } else {
                if (this.from == null) {
                    this.$router.push({
                        name: "Transaction",
                    });
                } else {
                    this.navigateBackOrHome();
                }
            }
        }
    },
    watch: {
        transaction: function () {
            //wait for dom to render iframe
            this.$nextTick(function () {
                this.resizePage();
            });
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.resizePage();
        })
    },
    beforeUnmount() {
        this.removeInterval();

        window.removeEventListener('resize', () => {
            this.resizePage();
        })
    },
};
</script>
  
<style>
.spin-animation {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>